/* eslint-disable react/prop-types */
import React from 'react';
import { hsvaToHslaString } from './ColorUtils';
import DragEvent from './DragEvent';
import { Pointer } from './Pointer';

export const BACKGROUND_IMG =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAMUlEQVQ4T2NkYGAQYcAP3uCTZhw1gGGYhAGBZIA/nYDCgBDAm9BGDWAAJyRCgLaBCAAgXwixzAS0pgAAAABJRU5ErkJggg==';

const Alpha = React.forwardRef((props, ref) => {
  const {
    prefixCls = 'saws-alpha',
    className,
    hsva,
    background,
    bgProps = {},
    innerProps = {},
    radius = 0,
    width,
    height = 16,
    direction = 'horizontal',
    style,
    onChange,
    pointer,
    ...other
  } = props;

  const handleChange = (offset) => {
    onChange && onChange({ ...hsva, a: direction === 'horizontal' ? offset.left : offset.top }, offset);
  };

  const colorTo = hsvaToHslaString(Object.assign({}, hsva, { a: 1 }));
  const innerBackground = `linear-gradient(to ${
    direction === 'horizontal' ? 'right' : 'bottom'
  }, rgba(244, 67, 54, 0) 0%, ${colorTo} 100%)`;

  const comProps = { left: undefined, top: undefined };
  if (direction === 'horizontal') {
    comProps.left = `${hsva.a * 100}%`;
  } else {
    comProps.top = `${hsva.a * 100}%`;
  }

  return (
    <div
      {...other}
      className={[prefixCls, `${prefixCls}-${direction}`, className || ''].filter(Boolean).join(' ')}
      style={{
        borderRadius: radius,
        background: `url(${BACKGROUND_IMG}) left center`,
        backgroundColor: '#fff',
        ...style,
        position: 'relative',
        ...{ width, height },
      }}
      ref={ref}
    >
      <div
        {...bgProps}
        style={{
          inset: 0,
          position: 'absolute',
          background: background || innerBackground,
          borderRadius: radius,
          ...bgProps.style,
        }}
      />
      <DragEvent
        {...innerProps}
        style={{
          ...innerProps.style,
          inset: 0,
          zIndex: 1,
          position: 'absolute',
        }}
        onMove={handleChange}
        onDown={handleChange}
      >
        {React.createElement(pointer || Pointer, {
          prefixCls,
          fillStyle: {
            width: 18,
            height: 18,
            transform: comProps.left ? 'translate(-9px, -1px)' : 'translate(-1px, -9px)',
            boxShadow: 'rgb(0 0 0 / 37%) 0px 1px 4px 0px',
            borderRadius: '50%',
            backgroundColor: 'rgb(248, 248, 248)',
          },
          ...comProps,
        })}
      </DragEvent>
    </div>
  );
});

Alpha.displayName = 'Alpha';

export default Alpha;
